import { render, staticRenderFns } from "./CollectionCard.vue?vue&type=template&id=3e28047c&"
import script from "./CollectionCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CollectionCard.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@4.3.0_lodash@4.17.21_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CollectionDetail: require('/vercel/path0/components/collection/CollectionDetail.vue').default})
